import { render, staticRenderFns } from "./tournamentPhase.vue?vue&type=template&id=8fe6081c"
import script from "./tournamentPhase.vue?vue&type=script&lang=js"
export * from "./tournamentPhase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports